import rdf, { QuadPosition } from '@ontologies/core';
import NdjsonStream from 'can-ndjson-stream';

var HexPosition;
(function (HexPosition) {
    HexPosition[HexPosition["Subject"] = 0] = "Subject";
    HexPosition[HexPosition["Predicate"] = 1] = "Predicate";
    HexPosition[HexPosition["Value"] = 2] = "Value";
    HexPosition[HexPosition["Datatype"] = 3] = "Datatype";
    HexPosition[HexPosition["Language"] = 4] = "Language";
    HexPosition[HexPosition["Graph"] = 5] = "Graph";
})(HexPosition || (HexPosition = {}));

const createLineParser = (rdfFactory = rdf) => {
    const bnMap = {};
    // Skip the (expensive) proxy object when parsing
    const quad = rdfFactory.quad.bind(rdfFactory);
    const literal = rdfFactory.literal.bind(rdfFactory);
    const namedNode = rdfFactory.namedNode.bind(rdfFactory);
    const blankNodeF = rdfFactory.blankNode.bind(rdfFactory);
    const defaultGraph = rdfFactory.defaultGraph.bind(rdfFactory);
    const blankNode = (v) => {
        if (!bnMap[v]) {
            bnMap[v] = blankNodeF();
        }
        return bnMap[v];
    };
    const object = (v, dt, l) => {
        if (l) {
            return literal(v, l);
        }
        else if (dt === "globalId") {
            return namedNode(v);
        }
        else if (dt === "localId") {
            return blankNode(v);
        }
        return literal(v, namedNode(dt));
    };
    return (h) => quad(h[HexPosition.Subject].startsWith("_:") ? blankNode(h[HexPosition.Subject]) : namedNode(h[HexPosition.Subject]), namedNode(h[HexPosition.Predicate]), object(h[HexPosition.Value], h[HexPosition.Datatype], h[HexPosition.Language]), h[HexPosition.Graph] ? namedNode(h[HexPosition.Graph]) : defaultGraph());
};

const hextupleStringParser = (bodyString, rdfFactory = rdf) => {
    const lineToQuad = createLineParser(rdfFactory);
    const delta = [];
    for (const line of bodyString.split("\n")) {
        if (line.length > 0) {
            delta.push(lineToQuad(JSON.parse(line)));
        }
    }
    return delta;
};

class HextuplesRDFLibParser {
    constructor(store, errorHandler = console.error) {
        this.store = store;
        this.rdfFactory = store.rdfFactory;
        this.errorHandler = errorHandler;
    }
    loadBuf(str) {
        this.addArr(this.parseString(str));
    }
    parseString(str) {
        return hextupleStringParser(str, this.rdfFactory).map((q) => [
            q.subject,
            q.predicate,
            q.object,
            q.graph,
        ]);
    }
    addArr(quads) {
        let q;
        for (let i = 0, len = quads.length; i < len; i++) {
            q = quads[i];
            if (q) {
                this.store.add(q[QuadPosition.subject], q[QuadPosition.predicate], q[QuadPosition.object], q[QuadPosition.graph]);
            }
        }
    }
}

let hasReadableStreamConstructor = false;
try {
    // tslint:disable-next-line:typedef no-empty no-unused-expression
    new ReadableStream({ start() { } });
    hasReadableStreamConstructor = true;
}
catch (e) {
    // ignore
}
const hextuplesTransformer = async (res, rdfFactory = rdf) => {
    const delta = [];
    let parse;
    if (res instanceof Response && hasReadableStreamConstructor) {
        const stream = new NdjsonStream(res.body);
        const reader = stream.getReader();
        const lineToQuad = createLineParser(rdfFactory);
        let read;
        parse = reader
            .read()
            .then(read = (result) => {
            if (result.done) {
                return;
            }
            delta.push(lineToQuad(result.value));
            return reader.read().then(read);
        });
    }
    else {
        let body;
        if (res instanceof Response) {
            body = res.text();
        }
        else if (typeof XMLHttpRequest !== "undefined"
            && res instanceof XMLHttpRequest
            || typeof res.responseText === "string") {
            body = Promise.resolve(res.responseText);
        }
        else {
            if (typeof res.body !== "string") {
                throw Error("Unsupported input format");
            }
            body = Promise.resolve(res.body);
        }
        parse = body
            .then((text) => {
            delta.push(...hextupleStringParser(text));
        });
    }
    await parse;
    return delta;
};

const hextupleMime = "application/hex+x-ndjson";

export { HexPosition, HextuplesRDFLibParser, createLineParser, hextupleMime, hextupleStringParser, hextuplesTransformer };
//# sourceMappingURL=index.js.map
